import React, {Component} from "react";

export const ChatContext = React.createContext({});

export default class ChatProvider extends Component {
  state = {
    showUserDetail: false,
    setShowUserDetail: (value: boolean) => {
      this.setState({ showUserDetail: value });
    },
    sameUserDetail: false,
    setSameUserDetail: (value: boolean) => {
      this.setState({ sameUserDetail: value });
    },
    userDetail: null,
    setUserDetail: (user: any) => {
      this.setState({ userDetail: user });
    },

    userSelectedId: null,
    setUserSelectedId: (userId: string) => {
      this.setState({ userSelectedId: userId });
    },
    showUserList: false,
    setShowUserList: (value: boolean) => {
      this.setState({ showUserList: value });
    },
    promoteMember: null,
    setPromoteMember: (role: string) => {
      this.setState({ promoteMember: role });
    },
    selectedUserId: [],
    setSelectedUserId: (userIds: string[]) => {
      this.setState({ selectedUserId: userIds });
    }
  };
  componentDidMount() {
    try {
    } catch (e) {}
  }

  render() {
    return (
      <ChatContext.Provider value={this.state}>
        {this.props.children}
      </ChatContext.Provider>
    );
  }
}
//@ts-ignore
ChatProvider.Consumer = ChatContext.Consumer;
